module.exports = __webpack_public_path__ + "img/2.343c3b28.jpg";